import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetObligation_alerts = z.any()
export type TagsGetObligation_alerts = z.infer<typeof tagsGetObligation_alerts>

export const querystringGetObligation_alerts = z.object({ "buildingId": z.string().uuid().optional() })
export type QuerystringGetObligation_alerts = z.infer<typeof querystringGetObligation_alerts>

export const responseGetObligation_alerts = z.object({ "payload": z.object({ "alerts": z.array(z.object({ "id": z.string(), "episodeId": z.string(), "ruleKey": z.string(), "scope": z.union([z.literal("building"), z.literal("municipality")]), "buildingId": z.string().optional(), "buildingName": z.string().optional(), "severity": z.union([z.literal("warning"), z.literal("info")]), "title": z.string(), "message": z.string(), "actionPath": z.string(), "actionLabel": z.string() })), "audit": z.object({ "years": z.array(z.object({ "year": z.number().int(), "mwh": z.number(), "complete": z.boolean() })), "warnings": z.array(z.string()) }).optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetObligation_alerts = z.infer<typeof responseGetObligation_alerts>

interface IGetObligation_alerts extends BaseMethodType {
  tags: TagsGetObligation_alerts,
  querystring: QuerystringGetObligation_alerts,
  response: ResponseGetObligation_alerts
}
export const URL = '/obligation-alerts'
export const validation = {
  get: {
    tags: tagsGetObligation_alerts,
    querystring: querystringGetObligation_alerts,
    response: responseGetObligation_alerts
  }
}
export interface Obligation_alerts extends BaseRouteType {
  get: IGetObligation_alerts
}